function groupBy(array, property) {
  if (array && property) {
    return array.reduce((result, item) => {
      const key = item[property];

      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(item);

      return result;
    }, []);
  }
  return null;
}

function groupByType({ array = [], type = '', sortProperty = '', sortOrder = 'asc' }) {
  if (!Array.isArray(array) || array.length === 0 || !type || !sortProperty) return [];

  // Make a shallow copy of the array to avoid mutating the original
  const sortedArray = [...array].sort((a, b) => b[sortProperty] - a[sortProperty]);

  // Grouping by type
  const grouped = sortedArray.reduce((acc, item) => {
    const key = item[type];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  // Convert the grouped object back into an array of objects with type and items
  const groupedArray = Object.keys(grouped).map((key) => ({
    type: key,
    items: grouped[key],
  }));

  // Sort the grouped array by type based on sortOrder
  return groupedArray.sort((a, b) => {
    if (sortOrder === 'asc') {
      return a.type.localeCompare(b.type);
    } else {
      return b.type.localeCompare(a.type);
    }
  });
}

function removeRedundantObjects({ array = [], property = '' }) {
  if (!array || array.length === 0 || !property) return [];

  const seen = new Set();
  return array.filter((item) => {
    const value = item[property];
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });
}

export { groupBy, groupByType, removeRedundantObjects };
